import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=4a81f70b&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"
import style0 from "./ServiceView.vue?vue&type=style&index=0&id=4a81f70b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81f70b",
  null
  
)

export default component.exports